import { getLowestAveragePrice } from '@/lib/search/mapSearchProperty';

function lowestPrice(prices, missingPrice) {
  return getLowestAveragePrice(prices) ?? missingPrice;
}

function compareAscending(left, right) {
  if (left === right) {
    return 0;
  }

  return left - right;
}

export const SORT_COMPARATORS = {
  lowestprice: (a, b) => compareAscending(
    lowestPrice(a.prices, Number.POSITIVE_INFINITY),
    lowestPrice(b.prices, Number.POSITIVE_INFINITY),
  ),
  lowestpricedorm: (a, b) => {
    const aPrice = a.prices?.dormsFrom ?? Number.POSITIVE_INFINITY;
    const bPrice = b.prices?.dormsFrom ?? Number.POSITIVE_INFINITY;
    return aPrice === bPrice ? 0 : aPrice - bPrice;
  },
  lowestpriceprivate: (a, b) => {
    const aPrice = a.prices?.privatesFrom ?? Number.POSITIVE_INFINITY;
    const bPrice = b.prices?.privatesFrom ?? Number.POSITIVE_INFINITY;
    return aPrice === bPrice ? 0 : aPrice - bPrice;
  },
  highestprice: (a, b) => compareAscending(
    lowestPrice(b.prices, Number.NEGATIVE_INFINITY),
    lowestPrice(a.prices, Number.NEGATIVE_INFINITY),
  ),
  rating: (a, b) => (b.rating?.total || 0) - (a.rating?.total || 0),
  distance: (a, b) => compareAscending(
    a.distance ?? Number.POSITIVE_INFINITY,
    b.distance ?? Number.POSITIVE_INFINITY,
  ),
  promotions: (a, b) => -(a.totalDiscount || 0) + (b.totalDiscount || 0),
};

/**
 * @param {object[]} properties
 * @param {string|null} sortKey
 * @returns {object[]} Sorted copy of the properties list, or the original list when unsorted.
 */
export function sortProperties(properties, sortKey) {
  const comparator = SORT_COMPARATORS[sortKey];
  if (!comparator) {
    return properties;
  }

  return [...properties].sort(comparator);
}
